import { EnabledIconProps, IconProps } from './IconProps';

export const ChevronIcon = ({
  className,
  height = 9,
  width = 14,
}: IconProps & EnabledIconProps) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox="0 0 14 9"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="m.5 6.881.5-.5L6.38 1l.5-.5.034.035L6.95.5l6.38 6.381-1.449 1.45-.5-.5-4.466-4.465L2.449 7.83l-.5.5L.5 6.88z"
      fill="#2396FD"
      fillRule="evenodd"
    />
  </svg>
);
